module.exports = __webpack_public_path__ + "img/logout-white.322a59ac.svg";